import script from "./Patent.vue?vue&type=script&setup=true&lang=js"
export * from "./Patent.vue?vue&type=script&setup=true&lang=js"

import "./Patent.vue?vue&type=style&index=0&id=6469df08&scoped=true&lang=less"

import exportComponent from "/var/www/tz-official-website/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6469df08"]])

export default __exports__